import { Breadcrumb, Link } from "@/atoms"
import { NAMES_ROUTES } from "@/const/routes.constants"
import { useTranslation } from "@/hooks/useTranslation"
import { HeaderPage } from "@/organisms/HeaderPage"

import type { IntegrationBreadcrumbHeaderProps } from "./IntegrationBreadcrumbHeader.types"

// Integrations > vendor > page, for the pages under an integration
export const IntegrationBreadcrumbHeader = (
  props: IntegrationBreadcrumbHeaderProps
) => {
  const { vendorName, vendorUrl, title } = props
  const { t } = useTranslation("translation", { keyPrefix: "navigation" })

  return (
    <HeaderPage
      title={
        <Breadcrumb
          items={[
            {
              title: (
                <Link to={`/${NAMES_ROUTES.INTEGRATIONS.ROOT}`}>
                  {t("integrations")}
                </Link>
              )
            },
            { title: <Link to={vendorUrl}>{vendorName}</Link> },
            { title }
          ]}
        />
      }
    />
  )
}
